module.exports = __webpack_public_path__ + "packs/media/images/palestraStrapiombi-1a45da055eb815622a9f2948fe421d2c.jpg";